import department from './department'
import contactMedia from './contact-media'
import contactCategory from './contact-category'
import contactSubcategory from './contact-subcategory'
import subject from './subject'
import contactSubject from './contact-subject'
import faqCategory from './faq-category'

export default {
  name: 'BaseInfoCrm',
  path: 'crm',
  meta: {
    label: 'crm',
    auth: 'crm'
  },
  component: {
    name: 'Crm',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    department,
    contactMedia,
    contactCategory,
    contactSubcategory,
    subject,
    contactSubject,
    faqCategory
  ]
}
